import React from 'react';
import { DropTargetMonitor } from 'react-dnd';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import classnames from 'classnames';
import './index.scss';

interface ITargetBoxProps {
  onDrop: (item: { files: any[] }) => void;
  hasFiles: boolean;
  disabled: boolean;
  children: React.ReactNode;
}

const TargetBox: React.FC<ITargetBoxProps> = props => {
  const { onDrop, hasFiles, disabled } = props;

  const [, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item: { files: any[] }) {
        if (onDrop) {
          onDrop(item);
        }
      },
      canDrop() {
        return true;
      },
      collect: (monitor: DropTargetMonitor) => {
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        };
      },
    }),
    [props]
  );

  return disabled ? (
    <div className="drop-area">{props.children}</div>
  ) : (
    <div className={classnames('drop-area', { 'has-files': hasFiles })} ref={drop}>
      {props.children}
    </div>
  );
};

export default TargetBox;
